import {USER_ROLES} from "@/constants";

export default class FloorPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        return true
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  floor
     * @return {mixed}
     */
    view(user, floor)
    {
        return true;
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  floor
     * @return {mixed}
     */
    update(user, floor)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  floor
     * @return {mixed}
     */
    restore(user, floor)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  floor
     * @return {mixed}
     */
    delete(user, floor)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  floor
     * @return {mixed}
     */
    forceDelete(user, floor)
    {
        //
    }
}
